const getSidebarOptions = state => state.common.sidebarOptions;
const getMessageNotification = state => state.common.messageNotification;
const getNotification = state =>state.common.getNotification
export default {
  getSidebarOptions,
  getMessageNotification,
  getNotification,
};
